export type GeoCountryModel = {
  active?: boolean,
  cache_key: number,
  calling_code?: string,
  code?: string,
  currency_code?: string,
  currency_symbol?: string,
  id: number,
  tax_rate?: number,
  title?: string,
}

const state = {
  active: true,
  calling_code: '',
  code: '',
  currency_code: '',
  currency_symbol: '',
  id: null,
  tax_rate: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
